import React, { useEffect, useState } from 'react';
import solution_one from '../assets/images/img_solution_one.png';
import solution_two from '../assets/images/img_solution_two.png';
import solution_three from '../assets/images/img_solution_three.png';
import solution_four from '../assets/images/img_solution_four.png';
import { Link } from 'react-router-dom';

function ExploreSolutions() {
    const [mobile,setMobile] = useState(false)
    
    const checkAnd = async () => {
        if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            setMobile({mobile:true})
        }
    }
    useEffect(()=>{
        checkAnd();
    },[])

    return (
        <section className="solutions-bg ">
            <div className="container ">
                <p className={!mobile? "header-solutions text-left ":"header-solutions"}>Explore Solutions</p>
                {!mobile ? 
                <div className="solutions-content text-left">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="solution-box">
                                <p className="solution-head">Private Cloud</p>
                                <p className="solution-body">Get the agility of Cloud with DETASAD Private Cloud, purpose built
                                for your requirements.</p>
                                <div className="row">
                                    <div className="col-md-7">
                                        <hr />
                                    </div>
                                    <div className="col-md-5">
                                        <Link className="view-more" to="/privatecloud" target="_blank">View more</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="image-two">
                                <img src={solution_one} className="img-fluid img-solutions" alt="" />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="security-box">
                                <p className="solution-head">Cloud Backup & Recovery</p>
                                <p className="solution-body">Protect data on cloud using cloud backup Services from DETASAD.</p>
                                <div className="row">
                                    <div className="col-md-7">
                                        <hr />
                                    </div>
                                    <div className="col-md-5">
                                        <Link className="view-more" to="/cloudbackupandrecovery" target="_blank">View more</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="image-two">
                                <img src={solution_two} className="img-fluid img-solutions-two" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="row second-solution-row">
                        <div className="col-md-3">
                            <div className="image-three">
                                <img src={solution_three} className="img-fluid img-solutions-three" alt="" />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="business-box">
                                <p className="solution-head">Disaster Recovery Service</p>
                                <p className="solution-body">Achieve enterprise grade business continuity by using DETASAD
                                cost-effective DR as a Service.</p>
                                <div className="row">
                                    <div className="col-md-7">
                                        <hr />
                                    </div>
                                    <div className="col-md-5">
                                        <Link className="view-more" to="/drasaservice" target="_blank">View more</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="image-four">
                                <img src={solution_four} className="img-fluid img-solutions-four" alt="" />
                            </div>
                        </div>
                        <div className="col-md-3 mb-2">
                            <div className="explore-box">
                                <p className="solution-head">Explore All Solutions</p>
                                <p className="solution-body">DETASAD has thousand solutions for your bsuiness, no matter you are
                                a individual or a big team.</p>
                                <div className="row">
                                    <div className="col-md-7">
                                        <hr />
                                    </div>
                                    <div className="col-md-5">
                                    <Link to={{pathname : process.env.REACT_APP_CONTACTUS}} target='_blank' className="view-more">Contact Us</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className="solutions-content">
                <div className="row">
                    <div className="col-md-3">
                        <div className="mobile-box">
                            <p className="solution-head">Private Cloud</p>
                            <p className="solution-body">Get the agility of Cloud with DETASAD Private Cloud, purpose built
                            for your requirements.</p>
                            <div className="row">
                                <div className="col-md-7">
                                    <hr />
                                </div>
                                <div className="col-md-4">
                                    <span className="view-more">View more</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="">
                            <img src={solution_one} className="img-thumbnail" alt="" />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="mobile-box mt-4">
                            <p className="solution-head">Cloud Backup & Recovery</p>
                            <p className="solution-body">Protect data on cloud using cloud backup Services from DETASAD.</p>
                            <div className="row">
                                <div className="col-md-7">
                                    <hr />
                                </div>
                                <div className="col-md-4">
                                    <span className="view-more">View more</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="">
                            <img src={solution_two} className="img-thumbnail" alt="" />
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-3">
                        <div className="">
                            <img src={solution_three} className="img-thumbnail" alt="" />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="mobile-box mt-4">
                            <p className="solution-head">Disaster Recovery Service</p>
                            <p className="solution-body">Achieve enterprise grade business continuity by using DETASAD
                            cost-effective DR as a Service.</p>
                            <div className="row">
                                <div className="col-md-7">
                                    <hr />
                                </div>
                                <div className="col-md-4">
                                    <span className="view-more">View more</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="">
                            <img src={solution_four} className="img-thumbnail" alt="" />
                        </div>
                    </div>
                    <div className="col-md-3 mb-2">
                        <div className="mobile-box mt-4">
                            <p className="solution-head">Explore All Solutions</p>
                            <p className="solution-body">DETASAD has thousand solutions for your bsuiness, no matter you are
                            a individual or a big team.</p>
                            <div className="row">
                                <div className="col-md-7">
                                    <hr />
                                </div>
                                <div className="col-md-4">
                                    <span className="view-more">View more</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                }
            </div>
        </section>
    );
}

export default ExploreSolutions;